// extracted by mini-css-extract-plugin
export default {"section":"ManagementReports_section__fAqzO","statCardWrapper":"ManagementReports_statCardWrapper__jD5nf"};